<template>
    <div class="justify-around flex flex-row items-center">
        <epi-link
            class="inline-block text-black opacity-75 hover:opacity-100 mr-3"
            url="https://www.facebook.com/Forebyggingno-265210116915435/?fref=ts"
            target="_new"
            title="Facebook (åpnes i ny fane)"
            content="Facebook (åpnes i ny fane)" v-tippy
        >
            <font-awesome-icon class="fa-fw" :icon="[ 'fab', 'facebook-square' ]" />
        </epi-link>
        <button
            class="inline-block text-black opacity-75 hover:opacity-100 mr-3"
            @click="print()"
            content="Skriv ut denne siden" v-tippy
        >
            <font-awesome-icon class="fa-fw" icon="print" />
        </button>
        <button class="inline-block text-black opacity-75 hover:opacity-100 mr-3" id="speaker"
                onClick="vFactClient.leseAct()"
                content="Lytt til tekst" v-tippy>
            <font-awesome-icon class="fa-fw" icon="volume-up" />
        </button>
        <div
            class="inline-block text-black opacity-75 hover:opacity-100 cursor-pointer"
            content="Hold Ctrl-tasten nede (Cmd på Mac).<br/>Trykk på + for å forstørre eller - for å forminske." v-tippy
        >
            <font-awesome-icon class="fa-fw" icon="text-height" />
        </div>
    </div>
</template>

<script>
import EpiLink from '@/Scripts/components/atoms/EpiLink/index.vue';
import Localized from '@/Scripts/components/atoms/Localized/localized.vue';

export default {
    props: ['model'],
    components: {
        EpiLink,
        Localized
    },
    methods: {
        print() {
            window.print();
        }
    }
};
</script>

<style>

</style>
